module.exports = __webpack_public_path__ + "static/media/empty-state-documents.0bc783bb.svg";